<template>
  <div class="org-signup">
    <br />
    <b-row>
      <b-col cols="3"> </b-col>

      <b-col cols="6">
        <b-card bg-variant="light" header="Sign Up" class="text-center">
          <b-form v-if="!loader">
            <b-form-group
              id="input-group-1"
              label="Token Key:"
              label-for="input-1"
              description="Please Enter the Token Key to add the Organzation to the Dashboard."
            >
              <b-input-group>
                <b-form-input
                  id="input-1"
                  v-model="form.token"
                  required
                  placeholder="Token Key"
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="!isHidden"
              id="input-group-2"
              label="Organization List:"
              label-for="input-2"
              description="Please select from the list of Organizations."
            >
              <b-form-select
                v-model="selected"
                :options="orgs"
                size="sm"
                class="mt-3"
                @change="getOrgInfo(selected)"
              >
              </b-form-select>
            </b-form-group>

            <b-button
              variant="primary"
              v-if="isHidden"
              v-on:click="verifyToken"
            >
              Click to fetch the list of Organizations
            </b-button>
          </b-form>
          <div v-if="loader">
            Give me a moment to grab the info.<br />
            This might take some time! <br />
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
        </b-card>
      </b-col>

      <b-col cols="3"></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        token: "",
        orgName: "",
      },
      orgs: [],
      selected: null,
      isHidden: true,
      loader: false,
      errorResponse: null,
    };
  },
  methods: {
    getOrgInfo(selected) {
      var token = "token " + this.form.token;
      const orgInfoUrl = "https://api.github.com/orgs/" + selected;
      const options = {
        headers: { Authorization: token },
      };

      fetch(orgInfoUrl, options)
        .then((res) => {
          if (!res.ok) {
            this.errorResponse = "Invalid Organization";
            this.showErrorResponse();
            location.reload();
            return null;
          }
          return res.json(); //we only get here if there is no error
        })
        .then((data) => {
          if (data === null) {
            return;
          }
          // console.log("orgInfo: ", data)
          this.$bvModal.show("my-modal");
          var name = "Name: " + data.name;
          var login = "Login: " + data.login;
          var orgid = data.id;
          var description = "Description: " + data.description;
          const h = this.$createElement;
          const messageVNode = h("div", { class: ["foobar"] }, [
            h("p", { class: ["text-center"] }, [name]),
            h("p", { class: ["text-center"] }, [login]),
            h("p", { class: ["text-center"] }, [description]),
          ]);
          this.$bvModal
            .msgBoxConfirm([messageVNode], {
              title: "Please Confirm",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: "YES",
              cancelTitle: "NO",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then((value) => {
              if (value) {
                // add to database
                var data = {
                  token: this.form.token,
                  orgid: orgid,
                };

                this.loader = true;

                this.$client
                  .post("add-organization", data)
                  .then(function() {
                    location.replace("/");
                  }) // todo: grab response and look at it. 
                  .catch((err) => {
                    console.log(err)
                    if (err.status) {
                      if (err.status == 403) {
                        this.errorResponse = "You are not authorized to perform this action.";
                      } else if (err.status == 409) {
                        this.errorResponse = "An error occurred. Is this a duplicate organization?";
                      }
                      else if (err.status && err.data) {
                        this.errorResponse = err.response.data;
                      }
                   } else { 
                      this.errorResponse = "An error occurred.";
                    }
                    this.showErrorResponse();
                  })
                  .finally(() => {
                    this.loader = false;
                  });
              } else {
                // do something
                // console.log("Value: ", value)
                this.$router.go();
              }
            })
            .catch((err) => {
              // An error occurred
              console.log("ERROR: ", err);
            });
          return "success";
        });
    },

    getOrgs(login, token) {
      this.orgs = [];
      // console.log("login: ", login)
      const orgUrl = "https://api.github.com/user/orgs";
      // console.log("orgUrl: ", orgUrl)
      const options = {
        headers: {
          Authorization: token,
        },
      };

      fetch(orgUrl, options)
        .then((res) => {
          if (!res.ok) {
            this.errorResponse = "Invalid Token";
            this.showErrorResponse();
          }
          return res.json(); //we only get here if there is no error
        })
        .then((data) => {
          var dataLength = data.length;
          if (dataLength !== 0) {
            this.isHidden = false;
            this.buttonInfo = "Choose and Select the Organization";
            for (var i = 0; i < dataLength; i++) {
              this.orgs.push(data[i].login);
            }
          } else {
            this.errorResponse = "No Organizations Found";
            this.showErrorResponse();
          }
          // console.log("Orgs: ", this.orgs)
          return this.orgs;
        });
    },

    verifyToken: function verifyToken(event) {
      event.preventDefault();

      var token = "token " + this.form.token;
      const userUrl = "https://api.github.com/user";

      const options = {
        headers: {
          Authorization: token,
        },
      };

      fetch(userUrl, options)
        .then((res) => {
          if (!res.ok) {
            this.errorResponse = "Invalid Token";
            this.showErrorResponse();
            return null;
          }
          return res.json(); //we only get here if there is no error
        })
        .then((data) => {
          if (data === null) {
            return;
          }
          this.login = data.login;
          // console.log("data: ", data)
          // console.log(this.login)
          this.getOrgs(this.login, token);
        });
    },
    showErrorResponse() {
      this.$bvModal
        .msgBoxOk(this.errorResponse, {
          title: "Alert",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          console.log(value);
          location.reload();
        });
    },
  },
};
</script>
